import { Link } from "react-router-dom";

interface ListOfQuestionProps {
  subject?: string;
  subjectId?: string;
  questions: {
    question: string;
    // questionReference: string;
    weightage: number
  }[];
}

const ListOfQuestion: React.FC<ListOfQuestionProps> = ({ subject,questions,subjectId }) => (
  <section className="listOfQuestionContainer">
    {questions.map((q, index) => (
      <Link
        key={`${q.question}-${index}`}
        to={`/dashboard/${q.question}`}
        className="block"
        state={{
          subjectName: subject,
          question: q.question,
          subjectId: subjectId,
        }}
      >
        <p className="listOfQuestionItem">
          <span>{q.question}</span> <span>({q.weightage})</span>
        </p>
      </Link>
    ))}

  </section>
);

export default ListOfQuestion;